<template>
  <v-tabs centered fixed-tabs>
    <v-tab>
      Mail
    </v-tab>
    <v-tab>
      WhatsApp
    </v-tab>
    <v-tab-item>
      <v-form ref="form">
        <v-text-field label="שם" v-model="name"></v-text-field>
        <v-autocomplete
          v-model="user"
          item-text="name"
          item-value="id"
          :items="teamMembers"
          return-object
        >
        </v-autocomplete>
        <v-text-field v-model="mail" label="Mail"></v-text-field>
        <v-textarea v-model="text"> </v-textarea>
      </v-form>
      <v-card>
        <v-card-title>
          תצוגה מקדימה
        </v-card-title>
        <v-card-text>
          {{ preview }}
        </v-card-text>
      </v-card>
      <br />
      <a :href="MailApiLink" target="_blank">
        <v-btn link color="primary">שליחה</v-btn>
      </a>
    </v-tab-item>
    <v-tab-item>
      <v-form ref="form">
        <v-text-field label="שם" v-model="name"></v-text-field>
        <v-autocomplete
          v-model="user"
          item-text="name"
          item-value="slug"
          :items="teamMembers"
          return-object
        >
        </v-autocomplete>
        <v-row>
          <v-col cols="2">
            <v-text-field v-model="region" label="Code"></v-text-field>
          </v-col>
          <v-col cols="10">
            <v-text-field v-model="phone" label="Standard"></v-text-field>
          </v-col>
        </v-row>
        <v-textarea v-model="text"> </v-textarea>
      </v-form>
      <v-card>
        <v-card-title>
          תצוגה מקדימה
        </v-card-title>
        <v-card-text>
          {{ preview }}
        </v-card-text>
      </v-card>
      <br />
      <a :href="waApiLink" target="_blank">
        <v-btn link :to="waApiLink" @click="onSubmit" color="primary"
          >שליחה</v-btn
        >
      </a>
    </v-tab-item>
  </v-tabs>
</template>

<script>
export default {
  data: () => {
    return {
      teamMembers: {},
      name: "",
      mail: "",
      region: "972",
      phone: "",
      user: "",
      text: `
שלום
בתקופת פורים אתם בטח נזכרים בפעילות הת"ת,
גם כיום לומדים בישיבה תלמידים הנצרכים לסיוע. 
אנחנו בת"ת פועלים לאורך השנים לסייע להם בכל העניינים מתוך הכרה שזה יאפשר להם להמשיך להתמיד בתורה ללא טרדות חיצוניות. 
בכדי להמשיך את המפעל האדיר הזה אנו זקוקים לעזרתך כדי לתת לת"ת לתת, 
כי אנחנו הת"ת של קול-תורה!

`,
    };
  },
  computed: {
    MailApiLink() {
      return encodeURI(
        `mailto:${this.mail}?subject=${this.subject}&body=${this.preview}`
      );
    },
    waApiLink() {
      return encodeURI(
        `https://web.whatsapp.com/send?phone=${this.region}${this.phone}&text=${this.preview}`
      );
    },
    preview() {
      return `שלום, ${this.name}\n${this.text}\n${this.link}`;
    },
    link() {
      return `https://metchy.com/kol_torah_k/${this.user.id}`;
    },
  },
  mounted() {
    this.fetchTeamMembers();
  },
  methods: {
    onSubmit(event) {
      return event.preventDefault();
    },
    async fetchTeamMembers() {
      const teamMembers = await fetch(
        "https://metchy.k.r0n.app/small/raiser"
      ).then((response) => response.json());
      this.teamMembers = teamMembers;
    },
  },
};
</script>

<style></style>
